import { render, staticRenderFns } from "./LayoutsDeEmails.vue?vue&type=template&id=892f9284&scoped=true"
import script from "./LayoutsDeEmails.vue?vue&type=script&lang=js"
export * from "./LayoutsDeEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892f9284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('892f9284')) {
      api.createRecord('892f9284', component.options)
    } else {
      api.reload('892f9284', component.options)
    }
    module.hot.accept("./LayoutsDeEmails.vue?vue&type=template&id=892f9284&scoped=true", function () {
      api.rerender('892f9284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/settings/LayoutsDeEmails.vue"
export default component.exports